var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEsg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    rx: 24,
    fill: "#EEF6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.1669 32.0556C41.1669 30.8473 41.6468 29.6886 42.5012 28.8343C43.3555 27.98 44.5142 27.5 45.7224 27.5H50.278C51.4862 27.5 52.6449 27.98 53.4992 28.8343C54.3536 29.6886 54.8335 30.8473 54.8335 32.0556C54.8335 33.2638 54.3536 34.4225 53.4992 35.2768C52.6449 36.1312 51.4862 36.6111 50.278 36.6111H45.7224C44.5142 36.6111 43.3555 36.1312 42.5012 35.2768C41.6468 34.4225 41.1669 33.2638 41.1669 32.0556Z",
    stroke: "#008CB7",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6675 66.2221L54.075 58.6295M38.8898 52.3024C38.8898 53.4656 39.1189 54.6175 39.564 55.6922C40.0092 56.7669 40.6617 57.7434 41.4842 58.5659C42.3068 59.3885 43.2833 60.041 44.358 60.4861C45.4327 60.9313 46.5845 61.1604 47.7478 61.1604C48.911 61.1604 50.0629 60.9313 51.1376 60.4861C52.2123 60.041 53.1888 59.3885 54.0114 58.5659C54.8339 57.7434 55.4864 56.7669 55.9315 55.6922C56.3767 54.6175 56.6058 53.4656 56.6058 52.3024C56.6058 51.1391 56.3767 49.9872 55.9315 48.9125C55.4864 47.8378 54.8339 46.8613 54.0114 46.0388C53.1888 45.2162 52.2123 44.5638 51.1376 44.1186C50.0629 43.6735 48.911 43.4443 47.7478 43.4443C46.5845 43.4443 45.4327 43.6735 44.358 44.1186C43.2833 44.5638 42.3068 45.2162 41.4842 46.0388C40.6617 46.8613 40.0092 47.8378 39.564 48.9125C39.1189 49.9872 38.8898 51.1391 38.8898 52.3024Z",
    stroke: "#008CB7",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.952 52.3025L46.4829 54.8333L51.5446 49.7716",
    stroke: "#008CB7",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6112 30.5555C35.0052 30.5555 33.4649 31.1935 32.3293 32.3292C31.1937 33.4648 30.5557 35.0051 30.5557 36.6111V63.9444C30.5557 65.5505 31.1937 67.0907 32.3293 68.2264C33.4649 69.362 35.0052 70 36.6112 70H59.389C59.8362 70 60.2783 69.9505 60.7079 69.8546L57.6655 67H36.6112C35.8008 67 35.0236 66.6781 34.4506 66.105C33.8776 65.532 33.5557 64.7548 33.5557 63.9444V36.6111C33.5557 35.8007 33.8776 35.0235 34.4506 34.4505C35.0236 33.8775 35.8008 33.5555 36.6112 33.5555H41.1668C41.9952 33.5555 42.6668 32.884 42.6668 32.0555C42.6668 31.2271 41.9952 30.5555 41.1668 30.5555H36.6112ZM62.4446 62.7917L65.2589 65.4323C65.3812 64.95 65.4446 64.4505 65.4446 63.9444V36.6111C65.4446 35.0051 64.8066 33.4648 63.6709 32.3292C62.5353 31.1935 60.995 30.5555 59.389 30.5555H54.8334C54.005 30.5555 53.3334 31.2271 53.3334 32.0555C53.3334 32.884 54.005 33.5555 54.8334 33.5555H59.389C60.1994 33.5555 60.9766 33.8775 61.5496 34.4505C62.1226 35.0235 62.4446 35.8007 62.4446 36.6111V62.7917Z",
    fill: "#008CB7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsg2);
export default __webpack_public_path__ + "static/media/esg2.0d171980a0690a98d70a5195e6722e79.svg";
export { ForwardRef as ReactComponent };